import React, { useState, useEffect, createContext } from "react";

// 🧩 Cursor context export
export const CursorContext = createContext();

const CursorProvider = ({ children }) => {
  // 🧩 Tracks current mouse position
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });

  // 🧩 Controls the current cursor style/variant
  const [cursorBG, setCursorBG] = useState("default");

  // 🧩 Check for mobile (disables custom cursor)
  const mobileViewportIsActive = window.innerWidth < 768;

  useEffect(() => {
    // 🧩 If not on mobile, enable cursor tracking
    if (!mobileViewportIsActive) {
      const move = (e) => {
        setCursorPos({ x: e.clientX, y: e.clientY });
      };
      window.addEventListener("mousemove", move);

      // 🧩 Cleanup on unmount
      return () => {
        window.removeEventListener("mousemove", move);
      };
    } else {
      // 🧩 Hide cursor entirely on mobile
      setCursorBG("none");
    }
  }, [mobileViewportIsActive]);

  const cursorVariants = {
    default: {
      x: cursorPos.x - 16,
      y: cursorPos.y - 16,
      backgroundColor: "#8B5CF6",
      // soft purple glow
      boxShadow:
        "0 0 0 4px rgba(139,92,246,0.15), 0 0 18px 4px rgba(139,92,246,0.35)",
      width: "32px",
      height: "32px",
    },
    text: {
      width: "56px",
      height: "56px",
      x: cursorPos.x - 28,
      y: cursorPos.y - 28,
      backgroundColor: "rgba(196,181,253,0.15)",
      border: "2px solid #A78BFA",
      // expanded glow on hover
      boxShadow:
        "0 0 0 6px rgba(139,92,246,0.10), 0 0 28px 8px rgba(139,92,246,0.30)",
      mixBlendMode: "normal",
    },
    none: {
      width: 0,
      height: 0,
      backgroundColor: "rgba(255,255,255,0)",
      boxShadow: "none",
    },
  };

  // 🧩 Call these on hover for interactive elements
  const mouseEnterHandler = () => setCursorBG("text");
  const mouseLeaveHandler = () => setCursorBG("default");

  return (
    <CursorContext.Provider
      value={{ cursorVariants, cursorBG, mouseEnterHandler, mouseLeaveHandler }}
    >
      {children}
    </CursorContext.Provider>
  );
};

export default CursorProvider;
